import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';
@Component({
  selector: 'app-job-board-sidenav',
  templateUrl: './job-board-sidenav.component.html',
  styleUrls: ['./job-board-sidenav.component.scss'],
})
export class JobBoardSidenavComponent implements OnChanges {
  @Input() cardData: any;
  @Input() cardType: any;
  @Input() tagData: any;
  @Output() public closeSideNav = new EventEmitter<any>();
  jobBoardTagAssignments: Array<any> = [];
  tagAssignments: Array<any> = [];

  constructor(
    private momentService: MomentService,
    private jobPointeService: JobPointeService,
  ) { }

  ngOnInit() {
    this.getCardType();
  }

  ngOnChanges() {
    this.tagAssignments = this.tagData;
    this.cardType = this.cardData?.cardType;

    if (this.cardData) {
      this.cardData.jobBoardAttributes = this.cardData?.jobBoardAttributes ?? []
      return
    }
  }

  get uniqueCertifications() {
    if (!this.cardData?.jobBoardAttributes) return [];

    return this.cardData.jobBoardAttributes.filter((attr, index, self) =>
      index === self.findIndex(a =>
        a.jobBoardAttribute?.id === attr.jobBoardAttribute?.id
      )
    );
  }

  removeCardTag(tagAssignment) {
    this.jobPointeService.delete['jobBoardTagAssignment']({
      id: tagAssignment.id,
    }).subscribe(
      res => {
        if (res.success) {
          this.tagAssignments = this.tagAssignments.filter(ta => ta.id != tagAssignment.id);
        }
      },
      err => {
        if (err.status == 404) {
          this.tagAssignments = this.tagAssignments.filter(ta => ta.id != tagAssignment.id);
        }
      },
    );
  }

  formatDate(date: string) {
    return date ? this.momentService.formateDate(date) : '';
  }

  getCardType() {
    this.cardType = this.cardData?.cardType;
    return this.cardType;
  }

  getFacilityJobs() {
    return this.cardData?.potentialJobDetail?.jobs.filter(j => !j.isSeparateOnJobBoard);
  }

  getFacilityAddress() {
    return `${this.cardData?.streetAddress.trim()},\
      ${this.cardData?.city.trim()},\
      ${this.cardData?.facilityState?.abbreviation},\
      ${this.cardData?.zipcode.trim()}`.trim();
  }

  getJobAddress() {
    const street = this.cardData?.street || this.cardData?.streetAddress || '';
    return `${street.trim()},\
      ${this.cardData?.city.trim()},\
      ${this.cardData?.taxStatus},\
      ${this.cardData?.zipCode}`.trim();
  }

  closeSideNavBar() {
    this.closeSideNav.emit(false);
  }
}
